import $ from 'jquery';
window.jQuery = window.$ = $;

$(window).on('scroll', function(){
	$('nav').toggleClass('scrolled', $(this).scrollTop() > 150);
	$('a.nav-link').toggleClass('nav-link-scroll-color', $(this).scrollTop() > 150);
});